import { render, staticRenderFns } from "./historical-update.vue?vue&type=template&id=2d3fda7d&scoped=true&"
import script from "./historical-update.vue?vue&type=script&lang=js&"
export * from "./historical-update.vue?vue&type=script&lang=js&"
import style0 from "./historical-update.vue?vue&type=style&index=0&id=2d3fda7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3fda7d",
  null
  
)

export default component.exports